var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:[_vm.color, {
      'nq-button': !_vm.small,
      'big-label': !_vm.small,
      'nq-button-s': _vm.small && _vm.color === 'gray',
      'nq-button-pill': _vm.small && _vm.color != 'gray',
      'go-back': _vm.back,
      'has-arrow': _vm.arrow || _vm.back,
      small: _vm.small, medium: _vm.medium, inverse: _vm.inverse, }],attrs:{"href":_vm.link ? _vm.link : null,"target":(_vm.link && _vm.link.startsWith('http')) ? '_blank' : '_self'},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('span',[_vm._v(_vm._s(_vm.text))]),(_vm.arrow || _vm.back)?_c('ArrowRightSmallIcon',{staticClass:"arrow"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }